<template>
  <transition name="modal">
    <slot />
  </transition>
</template>

<script>
export default {
  name: 'ModalTransition',
}
</script>

<style>
.modal-enter,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-to,
.modal-leave {
  opacity: 1;
}

.modal-enter-active,
.modal-leave-active {
  transition: all 0.5s;
}

.modal-enter .modal-container {
  transform: scale(1.1);
}

.modal-leave-active .modal-container {
  transform: scale(0.8);
}
</style>
